module.exports = __webpack_public_path__ + "media/images/application/template/footer-logo-7-2c887ef1e5f75b79d8c3fb3acd105efc.jpg";